// extracted by mini-css-extract-plugin
module.exports = {"switcher-popover":"zffGY-","switcherPopover":"zffGY-","popover-body":"SCvRH-","popoverBody":"SCvRH-","popover-label":"_2-hIk-","popoverLabel":"_2-hIk-"};